import fetch from '@/utils/fetch'

export const INDEX_CONTENT_SELF = 'self'
export const INDEX_CONTENT_SUB = 'sub'

export const TYPE_UNDEFINED = 'undefined'
export const TYPE_INTEGRAL = 'integral'
export const TYPE_NEWS = 'news'
export const TYPE_NEWS_LIST = 'newsList'
export const TYPE_PERSON = 'person'
export const TYPE_PERSON_LIST = 'personList'
export const TYPE_CUSTOMIZED = 'customized'
export const TYPE_ARTICLE = 'article'
export const TYPE_ARTICLE_LIST = 'articleList'

const BASE = '/column/'

export function getAllColumns () {
  return fetch({
    url: BASE + 'all',
    method: 'get'
  })
}

export function getMainColumnName (mainColumnId) {
  return fetch({
    url: BASE + mainColumnId + '/name',
    method: 'get'
  })
}

export function getSubColumnName (mainColumnId, subColumnId) {
  return fetch({
    url: BASE + mainColumnId + '/sub_column/' + subColumnId + '/name',
    method: 'get'
  })
}

export function getAllFriendLinks () {
  return fetch({
    url: BASE + 'friend_link/all',
    method: 'get'
  })
}

export function getAllBanners () {
  return fetch({
    url: BASE + 'banner/all',
    method: 'get'
  })
}

export function getWebsiteInfo () {
  return fetch({
    url: BASE + 'website_info',
    method: 'get'
  })
}

export function getMainColumnContentType (mainColumnId) {
  return fetch({
    url: BASE + mainColumnId + '/content_type',
    method: 'get'
  })
}

export function getSubColumnContentType (mainColumnId, subColumnId) {
  return fetch({
    url: BASE + mainColumnId + '/sub_column/' + subColumnId + '/content_type',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/column.js